// Helper that builds <option> elements via React.createElement.
//
// Why this exists: the platform's visual-editor build instrumentation wraps
// JSX-iterated children in a <span style="display:contents"> for source
// tracking. When the iterated child is an <option>, the resulting markup is
// <select><span><option/></span></select> — invalid HTML which triggers a
// React hydration warning ("<option> cannot be a child of <span>").
//
// Calling React.createElement directly bypasses the JSX instrumentation, so
// the rendered DOM stays as <select><option/></select>. Use this helper for
// any dynamic/mapped <option> list inside a native <select>.
import { createElement } from "react";

export function nativeOption(value, label, key = value) {
  return createElement("option", { key, value }, label);
}

export function nativeOptions(items, mapper) {
  return items.map((item, idx) => {
    const { value, label, key } = mapper(item, idx);
    return createElement("option", { key: key ?? value ?? idx, value }, label);
  });
}
